import makeStyles from '@mui/styles/makeStyles';
export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    marginRight: theme.spacing(4),
    marginLeft: theme.spacing(4),
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
      width: '0', 
      minWidth: '0',
    },
    '&::-moz-scrollbar-track': {
      width: '0',
      minWidth: '0',
    },
    '&::-webkit-scrollbar-track': {
      width: '0',
      minWidth: '0',
    },
    '&::-webkit-scrollbar': {
      width: '0',
      minWidth: '0',
    },
    '&::-webkit-scrollbar-thumb': {
      width: '0',
      minWidth: '0',
    },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      marginTop: theme.spacing(1),
      marginInlineStart: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  content: {
    minWidth: 500,
    padding: '25px',
    paddingTop: '20px',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      padding: '12px 20px',
    },
  },
  actions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: '15px',
    padding: '20px 20px 22px',
  },
  title: {
    color: '#003a52',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  detailsPage: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  serviceSetModal: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  dialog: {
    textAlign: 'right',
    direction: 'rtl',
    background: '#f3f3f3',
    padding: theme.spacing(2),
    lineHeight: 2,
  },
}));
